module.exports = __webpack_public_path__ + "static/media/Letter to Vendors on TCS.91b47b25.pdf";